module.exports = __webpack_public_path__ + "static/img/segment-icon.327d28c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/segment-icon.svg
// module id = 1449
// module chunks = 0